import React from "react";
import { Button, Icon, Toolbar } from "./StaleComponents";
import { useSlate } from "slate-react";
import isMarkActive from "./utils/isMarkActive";
import toggleMark from "./utils/toggleMark";
import { AddLinkButton, RemoveLinkButton } from "./plugins/LinkButtons";
import { AddEmojiButton } from "./plugins/EmojiButtons";
import ImageButton from "./plugins/ImageButton";
import { Box } from "@mantine/core";
import AttachFileButton from "./plugins/FileButton";

const StaleToolbar = ({ setImages, images, handleFileUpload }) => {
  return (
    <Box style={{ marginTop: images.length ? "10px" : 0 }}>
      <Toolbar>
        <MarkButton format="bold" icon="format_bold" />
        <MarkButton format="italic" icon="format_italic" />
        <MarkButton format="underline" icon="format_underlined" />
        <MarkButton format="code" icon="code" />
        <AddLinkButton />
        <RemoveLinkButton />
        <AddEmojiButton />
        <ImageButton setImages={setImages} images={images} />
        <AttachFileButton handleFileUpload={handleFileUpload}/>
      </Toolbar>
    </Box>
  );
};

export default StaleToolbar;

const MarkButton = ({ format, icon }) => {
  const editor = useSlate();
  return (
    <Button
      active={isMarkActive(editor, format)}
      onMouseDown={(event) => {
        event.preventDefault();
        toggleMark(editor, format);
      }}
    >
      <Icon>{icon}</Icon>
    </Button>
  );
};
